import { useNavigate } from 'react-router-dom';
import Img1 from '../../../assets/image/img_multi-intelligence_1.jpg';
import Img2 from '../../../assets/image/img_multi-intelligence_2.jpg';
import Img3 from '../../../assets/image/img_multi-intelligence_3.jpg';
import FullHeightContainer from '../../../component/common/FullHeightContainer';
import TopHeaderWithPrev from '../../../component/common/TopHeaderWithPrev';
import { useTranslation } from '../../../hook/useTranslation';

interface TitleProps {
  title: string;
}

function Title({ title }: TitleProps) {
  return (
    <div className="text-[20px] text-[1C1C1C] w-full text-left font-[700] mb-[20px]">{title}</div>
  );
}

interface DotTextProps {
  text: string;
}

function DotText({ text }: DotTextProps) {
  return (
    <div className="w-full flex items-start justify-start gap-[8px]">
      <div className="flex items-start justify-start">･</div>
      <div className="text-[14px] text-[#363636] w-full text-left font-[400] leading-[22px]">
        {text}
      </div>
    </div>
  );
}

interface SubjectTextProps {
  subject: string;
  text: string;
}

function SubjectText({ subject, text }: SubjectTextProps) {
  return (
    <div className="w-full flex flex-col items-start justify-start gap-[1px]">
      <div className="w-full flex items-start text-[14px] font-[700] justify-start gap-[8px]">
        <div className="flex items-start justify-start">･</div>
        <div className="text-[14px] text-[#363636] w-full text-left">{subject}</div>
      </div>
      <div className="w-full flex items-start justify-start gap-[8px]">
        <div className="flex items-start justify-start">&nbsp;&nbsp;</div>
        <div className="text-[14px] text-[#363636] w-full text-left font-[400]">{text}</div>
      </div>
    </div>
  );
}

export default function MultiIntelligenceIntro() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <FullHeightContainer>
      <TopHeaderWithPrev title={t('home.multi_intelligence.title')} onClickPrev={() => navigate(-1)} />
      <div className="pageInner bg-[#FFF]">
        <img
          src={Img1}
          alt="1"
          style={{ objectFit: 'contain' }}
          className="mb-[40px]"
        />
        <Title title={t('home.multi_intelligence.intro_title')} />
        <div className="w-full flex items-start justify-start gap-[8px]">
          <div className="text-[14px] text-[#363636] w-full text-left font-[400] leading-[22px]">
            {t('home.multi_intelligence.intro_desc')}
          </div>
        </div>
        <img
          src={Img2}
          alt="2"
          style={{ objectFit: 'contain' }}
          className="my-[40px]"
        />
        <Title title={t('home.multi_intelligence.feature_title')} />
        <DotText text={t('home.multi_intelligence.feature_1')} />
        <div className="w-full flex items-start justify-start gap-[8px]">
          <div className="flex items-start justify-start">･</div>
          <div className="text-[14px] text-[#363636] w-full text-left font-[400] leading-[22px]">
            {t('home.multi_intelligence.feature_2')}
          </div>
        </div>
        <div className="w-full flex items-start justify-start gap-[8px]">
          <div className="flex items-start justify-start">･</div>
          <div className="text-[14px] text-[#363636] w-full text-left font-[400] leading-[22px]">
            {t('home.multi_intelligence.feature_3')}
          </div>
        </div>
        <DotText text={t('home.multi_intelligence.feature_4')} />
        <DotText text={t('home.multi_intelligence.feature_5')} />
        <div className="w-full flex items-start justify-start gap-[8px]">
          <div className="flex items-start justify-start">･</div>
          <div className="text-[14px] text-[#363636] w-full text-left font-[400] leading-[22px]">
            {t('home.multi_intelligence.feature_6')}
          </div>
        </div>
        <img
          src={Img3}
          alt="3"
          style={{ objectFit: 'contain' }}
          className="my-[40px]"
        />
        <Title title={t('home.multi_intelligence.types_title')} />
        <div className="w-full flex flex-col items-start justify-start gap-[20px]">
          <SubjectText subject={t('talent.relationship')} text={t('home.multi_intelligence.type_relationship_desc')} />
          <SubjectText subject={t('talent.language')} text={t('home.multi_intelligence.type_language_desc')} />
          <SubjectText subject={t('talent.math')} text={t('home.multi_intelligence.type_math_desc')} />
          <SubjectText subject={t('talent.physical')} text={t('home.multi_intelligence.type_physical_desc')} />
          <SubjectText subject={t('talent.reflection')} text={t('home.multi_intelligence.type_reflection_desc')} />
          <SubjectText subject={t('talent.nature')} text={t('home.multi_intelligence.type_nature_desc')} />
          <SubjectText subject={t('talent.space')} text={t('home.multi_intelligence.type_space_desc')} />
          <SubjectText subject={t('talent.music')} text={t('home.multi_intelligence.type_music_desc')} />
        </div>
      </div>
    </FullHeightContainer>
  );
}
